import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import {
  Home as HomeIcon,
} from '@mui/icons-material';
import { useTheme } from 'styled-components';
import { NavHeader } from '../../components/NavHeader';
import { Container } from './styles';
import { useAuth } from '../../context';
import { PlanStatus } from '../../types/enums';

export function CheckoutSuccess() {
  const { user } = useAuth();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/feed');
  };
  useEffect(() => {
    if (user.userPlan?.status === PlanStatus.ACTIVE && user.userPlan.expirationDate && new Date(user.userPlan.expirationDate) > new Date()) {
      navigate('/feed');
    }
  }, [user]);
  return (
    <>
      <NavHeader typeHeader="default" />
      <Container>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="60vh"
          gap={3}
        >
          <CircularProgress size={60} sx={{ color: theme.colors.primary }} />

          <Typography variant="h4" component="h1" color={theme.colors.secondary} textAlign="center" gutterBottom>
            Pagamento em Processamento
          </Typography>

          <Typography variant="body1" color="text.secondary" textAlign="center" mb={3} sx={{ maxWidth: 500 }}>
            Seu pagamento está sendo processado. Em breve você terá acesso completo ao sistema.
          </Typography>

          <Button
            variant="outlined"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
            sx={{
              borderColor: theme.colors.primary,
              color: theme.colors.primary,
              '&:hover': {
                borderColor: theme.colors.primary,
                backgroundColor: theme.colors.primary_100,
              },
            }}
          >
            Voltar ao Início
          </Button>
        </Box>
      </Container>
    </>
  );
}
